var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    width: "48px",
    height: "48px",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId,
    stroke: "#2329D6",
    strokeWidth: 1,
    strokeLinecap: "square",
    strokeLinejoin: "miter",
    fill: "none",
    color: "#2329D6",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dropIconTitle"
  }, "Drop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "dropIconTitle"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "dropIconDesc"
  }, "Icon of a single liquid drop")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,21 C15.3137085,21 18,18.3904147 18,15 C18,11.6666667 16,8 12,4 C8,8 6,11.6666667 6,15 C6,18.3904147 8.6862915,21 12,21 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrop);
export default __webpack_public_path__ + "static/media/drop.6ad311e6ad26b36ea561860677bb1331.svg";
export { ForwardRef as ReactComponent };